module.exports = __webpack_public_path__ + "static/media/hammer-icon.347e80c5.svg";